export const useCourseApi = {
  getCoursesById: (id) => {
    return `v3/courses/categories/${id}/courses`;
  },
};
